import { getPage } from './getPage';
import type { PageGroupItemViewModel } from '@trinnvis/dabih-api-client';

export function _pageName(pageId: number, pages: PageGroupItemViewModel[]): string {
  const page = getPage(pageId, pages);
  if (page) {
    return page.name;
  }
  return '';
}
